import React from 'react';
import { API_ENDPOINTS } from '../../constants/ApiEndpoints';
import { useTranslation } from 'react-i18next';
import { Fetch } from '@fides/fides-react-components';

interface FetchPortalUrlProps {
  children: (portalUrl: string) => React.ReactNode;
}

const FetchPortalUrl = (props: FetchPortalUrlProps) => {
  const { t } = useTranslation();

  return (
    <Fetch<string>
      endpoint={API_ENDPOINTS.config.portal}
      method="GET"
      children={props.children}
      useLoadingOverlay={true}
      loadingText={t('generic.loadingConfig')}
    />
  )
};

export default FetchPortalUrl;